// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore

const get = (obj, path, defaultValue = null) => {
  let computedPath;
  if (typeof path === "string") {
    computedPath = String.prototype.split
      .call(path, /[,[\].]+?/)
      .filter(Boolean);
  } else {
    computedPath = path;
  }

  return computedPath.reduce((a, c) => {
    try {
      return Object.hasOwnProperty.call(a, c) ? a[c] : defaultValue;
    } catch (err) {
      return defaultValue;
    }
  }, obj);
};
export default get;
